import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "../components/Layout";
import { Mail, FileText, Clock } from "lucide-react";

export default function Kontakt() {
  const { t } = useTranslation();
  const k = (key) => t(`kontakt.${key}`);
  return (
    <Layout withSidebar={false}>
      <div className="max-w-3xl mx-auto" data-testid="kontakt-page">
        <header className="mb-12">
          <div className="font-meta text-[var(--magenta)] mb-3">{k("section_label")}</div>
          <h1 className="font-fraunces italic text-4xl sm:text-5xl text-[var(--cream)] leading-tight mb-4">
            {k("title")}
          </h1>
          <p className="text-[var(--cream-soft)] leading-relaxed">
            {k("intro")}
          </p>
        </header>

        <section className="mb-10 panel p-8 border-l-4 border-[var(--magenta)]">
          <div className="flex items-start gap-4">
            <Mail className="h-7 w-7 text-[var(--magenta)] shrink-0 mt-1" />
            <div className="flex-1">
              <h2 className="font-fraunces italic text-2xl text-[var(--cream)] mb-3">{k("email_heading")}</h2>
              <a
                href="mailto:kontakt@norskerotikk.no"
                className="text-[var(--magenta)] hover:underline text-2xl font-fraunces"
                data-testid="contact-main-email"
              >
                kontakt@norskerotikk.no
              </a>
              <p className="text-[var(--cream-soft)] mt-4 leading-relaxed">
                {k("use_for")}
              </p>
              <ul className="list-disc pl-5 text-[var(--cream-soft)] space-y-1 mt-2">
                <li>{k("use_1")}</li>
                <li>{k("use_2")}</li>
                <li>{k("use_3")}</li>
                <li>{k("use_4")}</li>
                <li>{k("use_5")}</li>
              </ul>
              <div className="font-meta text-[10px] text-[var(--cream-faint)] mt-4 inline-flex items-center gap-2">
                <Clock className="h-3 w-3" /> {k("response_time")}
              </div>
            </div>
          </div>
        </section>

        <section className="mb-10 panel p-6 border-l-4 border-red-500">
          <h2 className="font-fraunces italic text-xl text-[var(--cream)] mb-2">{k("urgent_heading")}</h2>
          <p className="text-[var(--cream-soft)] leading-relaxed">
            {k("urgent_text")}
          </p>
        </section>

        <section className="mb-10 panel p-6">
          <h2 className="font-fraunces italic text-2xl text-[var(--cream)] mb-4">{k("company")}</h2>
          <dl className="space-y-3 text-[var(--cream-soft)]">
            <div className="flex">
              <dt className="font-meta w-40 text-[var(--cream-faint)]">{k("f_service")}</dt>
              <dd>Norsk Erotikk</dd>
            </div>
            <div className="flex">
              <dt className="font-meta w-40 text-[var(--cream-faint)]">{k("f_website")}</dt>
              <dd>
                <a href="https://norskerotikk.no" className="text-[var(--magenta)] hover:underline">
                  norskerotikk.no
                </a>
              </dd>
            </div>
            <div className="flex">
              <dt className="font-meta w-40 text-[var(--cream-faint)]">{k("f_provider")}</dt>
              <dd>{k("f_provider_value")}</dd>
            </div>
            <div className="flex">
              <dt className="font-meta w-40 text-[var(--cream-faint)]">{k("f_address")}</dt>
              <dd>{k("f_address_value")}</dd>
            </div>
          </dl>
        </section>

        <section className="panel p-6">
          <h2 className="font-fraunces italic text-2xl text-[var(--cream)] mb-4">{k("legal_docs")}</h2>
          <div className="grid sm:grid-cols-3 gap-3">
            <Link
              to="/vilkar"
              className="flex items-center gap-2 px-4 py-3 border border-white/10 hover:border-[var(--magenta)] hover:text-[var(--magenta)] text-[var(--cream)] transition-colors"
              data-testid="contact-link-vilkar"
            >
              <FileText className="h-4 w-4" /> {k("link_terms")}
            </Link>
            <Link
              to="/personvern"
              className="flex items-center gap-2 px-4 py-3 border border-white/10 hover:border-[var(--magenta)] hover:text-[var(--magenta)] text-[var(--cream)] transition-colors"
              data-testid="contact-link-personvern"
            >
              <FileText className="h-4 w-4" /> {k("link_privacy")}
            </Link>
            <Link
              to="/husregler"
              className="flex items-center gap-2 px-4 py-3 border border-white/10 hover:border-[var(--magenta)] hover:text-[var(--magenta)] text-[var(--cream)] transition-colors"
              data-testid="contact-link-husregler"
            >
              <FileText className="h-4 w-4" /> {k("link_house")}
            </Link>
          </div>
        </section>
      </div>
    </Layout>
  );
}
